import React, { Component, Fragment } from "react";
import ChartHolder from "./section1/chartHolder";
import TableHolder from "./section2/tableHolder";
import CircleArcHolder from "./circleArc/circleArcHolder";

class PortfolioGrowth extends Component {
  state = {
    getBacktest: [],
    initialDate: "",
    endDate: "",
    BenchmarkVami: [],
    PortfolioVami: [],
    minDate: "",
    maxDate: "",
    spinner: true,
    selected: "lineChart",
    getBacktest_orig: [],
    newBenchmarkName: "",
    portfolio_growth_table_data: [],
    portfolio_growth_table_heading: [],
  };

  componentDidMount() {
    const { origOBJ, clientBacktestData, getBacktest } = this.props;

    if (getBacktest) {
      if (getBacktest.getBenchmarkVami.length > 0) {
        const initialDate = getBacktest.getBenchmarkVami[0].dt;
        const endDate =
          getBacktest.getBenchmarkVami[getBacktest.getBenchmarkVami.length - 1]
            .dt;

        let minDate = initialDate;
        let maxDate = endDate;
        this.setState({
          getBacktest: getBacktest,
          BenchmarkVami: getBacktest.getBenchmarkVami,
          PortfolioVami: getBacktest.getPortfolioVami,
          initialDate: initialDate,
          endDate: endDate,
          minDate: minDate,
          maxDate: maxDate,
          spinner: false,
        });
      }
    }

    if (Object.keys(clientBacktestData).length > 0) {
      this.setState({
        getBacktest_orig: clientBacktestData,
        newBenchmarkName: "Orginal portfolio",
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { origOBJ, clientBacktestData, getBacktest } = nextProps;
    if (
      JSON.stringify(clientBacktestData) !==
      JSON.stringify(this.props.clientBacktestData)
    ) {
      if (Object.keys(clientBacktestData).length > 0) {
        this.setState({
          getBacktest_orig: clientBacktestData,
          newBenchmarkName: "Orginal portfolio",
        });
      }
    }

    if (
      JSON.stringify(this.props.getBacktest) !== JSON.stringify(getBacktest)
    ) {
      if (getBacktest.getBenchmarkVami.length > 0) {
        const initialDate = getBacktest.getBenchmarkVami[0].dt;
        const endDate =
          getBacktest.getBenchmarkVami[getBacktest.getBenchmarkVami.length - 1]
            .dt;

        let minDate = initialDate;
        let maxDate = endDate;
        this.setState({
          getBacktest: getBacktest,
          BenchmarkVami: getBacktest.getBenchmarkVami,
          PortfolioVami: getBacktest.getPortfolioVami,
          initialDate: initialDate,
          endDate: endDate,
          minDate: minDate,
          maxDate: maxDate,
          spinner: false,
          newBenchmarkName: getBacktest.getBenchmarkVami[0].benchmark_name,
        });
      }
    }
  }

  updateInputValue1 = (e) => {
    this.setState({
      initialDate: e.target.value,
    });
  };
  updateInputValue2 = (e) => {
    this.setState({
      endDate: e.target.value,
    });
  };

  hamburgerHandler = (e) => {
    e.preventDefault();
    if (e.target.name) {
      this.setState({
        selected: e.target.name,
      });
    }
  };

  render() {
    const {
      initialDate,
      endDate,
      minDate,
      maxDate,
      res,
      selected,
      getBacktest,
      BenchmarkVami,
      PortfolioVami,
      newBenchmarkName,
    } = this.state;
    const {
      port_info,
      compare_histmetrics,
      HistMetricsLive,
      display_orig_portfolio,
      model_name,
      typeName,
      benchmark_name,
      portfolio_growth_table_heading,
      portfolio_growth_table_data,
    } = this.props;

    return (
      <div className="row">
        <div
          className="col-lg-7 col-md-7 col-sm-12 col-xs-12"
          id="line_chartd3"
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "space-between",
            }}
          >
            <div>
              <h4 className="text-uppercase bold" style={{ display: "inline" }}>
                portfolio growth
              </h4>
            </div>
            <div className="portfolio_input">
              <div>
                From
                <input
                  type="date"
                  palceholder="dd-mm-yy"
                  min={minDate}
                  max={maxDate}
                  value={initialDate}
                  onChange={this.updateInputValue1}
                />
              </div>
              <div>
                To
                <input
                  type="date"
                  placeholder="dd-mm-yy"
                  min={minDate}
                  max={maxDate}
                  value={endDate}
                  onChange={this.updateInputValue2}
                />
              </div>
            </div>
          </div>
          {BenchmarkVami.length && PortfolioVami.length ? (
            <ChartHolder
              {...this.state}
              {...this.props}
              initialDate={initialDate}
              endDate={endDate}
              benchmark_name={benchmark_name}
              display_orig_portfolio={display_orig_portfolio}
              BenchmarkVami={BenchmarkVami}
              PortfolioVami={PortfolioVami}
              getBacktest={getBacktest}
              selected={selected}
              typeName={typeName}
              onclickHandler={this.hamburgerHandler}
              newBenchmarkName={newBenchmarkName}
            />
          ) : null}
          <Fragment>
            {portfolio_growth_table_data.length && selected === "lineChart" ? (
              <TableHolder
                portfolio_growth_table_heading={portfolio_growth_table_heading}
                portfolio_growth_table_data={portfolio_growth_table_data}
                HistMetricsLive={HistMetricsLive}
              />
            ) : null}
          </Fragment>
          <div>
            <small>
              {display_orig_portfolio
                ? `* ${benchmark_name}`
                : newBenchmarkName
                ? `* ${newBenchmarkName}`
                : null}
            </small>
          </div>

          {model_name ? (
            <div>
              <small>
                <b>+&nbsp;</b>
                {model_name}
              </small>{" "}
            </div>
          ) : null}
        </div>
        {BenchmarkVami.length && PortfolioVami.length ? (
          <CircleArcHolder
            {...this.props}
            newBenchmarkName={newBenchmarkName}
          />
        ) : null}
      </div>
    );
  }
}

export default PortfolioGrowth;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/performance/portfolioGrowth/PortfolioGrowth.jsx